<template>
  <div
    class="bg-white px-4 md:px-6 pt-4 pb-5 rounded-tr-lg rounded-tl-lg md:rounded-tr-none md:rounded-tl-none md:rounded-br-lg md:rounded-bl-lg"
  >
    <h3 class="font-bold text-lg mb-2 text-center md:text-left">
      {{ $t('start') }}
    </h3>
    <div class="flex justify-between sm:justify-center -mx-2">
      <div v-for="[key, value] in Object.entries(diff)" :key="key" class="px-2">
        <div class="flex">
          <div class="mr-1">
            <div class="digit">
              {{ value >= 10 ? value[0] : '0' }}
            </div>
          </div>
          <div>
            <div class="digit">
              {{ value >= 10 ? value[1] : value[0] }}
            </div>
          </div>
        </div>

        <div class="w-full mt-1">
          <span class="text-xs">{{ $tc(key, value) }}</span>
        </div>
      </div>
    </div>
    <div v-if="isOver" class="mt-2">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { differenceInSeconds, addSeconds } from 'date-fns';

export default Vue.extend({
  props: {
    appointment: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      interval: null,
      now: new Date()
    };
  },

  computed: {
    date() {
      // return addSeconds(new Date(), 5);
      return new Date(this.appointment.startDate);
    },
    isOver() {
      return differenceInSeconds(this.date, this.now) <= 0;
    },
    diff() {
      const distance = differenceInSeconds(this.date, this.now);

      const days = Math.floor(distance / (60 * 60 * 24));
      const hours = Math.floor((distance % (60 * 60 * 24)) / (60 * 60));
      const minutes = Math.floor((distance % (60 * 60)) / 60);
      const seconds = Math.floor(distance % 60);

      return {
        days: (days < 0 ? 0 : days).toString(),
        hours: (hours < 0 ? 0 : hours).toString(),
        minutes: (minutes < 0 ? 0 : minutes).toString(),
        seconds: (seconds < 0 ? 0 : seconds).toString()
      };
    }
  },

  methods: {
    updateDate() {
      this.now = new Date();
    }
  },

  created() {
    this.interval = setInterval(this.updateDate, 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }
});
</script>

<style lang="scss" scoped>
.digit {
  @apply bg-gray leading-none text-blue text-lg font-bold rounded text-center leading-none;
  padding: .5rem 0;
  width: 1.75rem;

  @screen md {
    padding: .4rem 0;
    @apply text-xl;
  }
}
</style>
